<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <el-card class="card">
          <div class="main">
            <div style="float: left;height: 2em;align-items: center;display: flex;width: 100%;margin-bottom: 1em;">
              <div style="display: flex;width: 4.5em;border-right: 1px solid #DCDFE6;cursor: pointer; " @click="goBack">
                <i class="el-icon-back" style="font-size: 18px;"></i>
                <div style="font-size: 0.9em;margin-left: 0.4em;">{{ $t('home.back') }}</div>
              </div>
              <div style="margin-left: 1.1em;font-size: 18px;">{{ $t('home.leaveMessage') }}</div>
            </div>
            <div class="title">
              {{ $t('home.contactUs') }}
            </div>
            <div class="tip" v-html="$t('home.leaveMessageTip')">
            </div>
            <el-form :model="form" :rules="$i18n.locale == 'zh'?rulesZh:rulesEn" ref="form" label-width="80px"
                     class="demo-ruleForm">
              <el-form-item :label="$t('home.name')" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('home.email')" prop="mail">
                <el-input v-model="form.mail"></el-input>
              </el-form-item>
              <el-form-item :label="$t('home.theme')" prop="title">
                <el-input v-model="form.title"></el-input>
              </el-form-item>
              <el-form-item :label="$t('home.text')" prop="content">
                <el-input v-model="form.content" type="textarea" :rows="8"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm()"> {{ $t('home.submit') }}</el-button>
                <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
              </el-form-item>
            </el-form>
          </div>

        </el-card>

      </div>
    </div>
    <!-- <shareDialog ref="shareDialog"></shareDialog> -->
  </div>
</template>

<script>
import {addMessageBoard} from "../../api/messageBoard";

export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      iconUrl: require('@/components/contact/imgs/icon.png'),
      imageList: [
        {
          url: require('@/components/contact/imgs/contact_img1.png'),
          title: "电话",
          content: "0871-8866888"
        },
        {
          url: require('@/components/contact/imgs/contact_img2.png'),
          title: "传真",
          content: "0871-8866888"
        },
        {
          url: require('@/components/contact/imgs/contact_img3.png'),
          title: "微信公众号",
          content: "澜湄执法合作中心LMLECC"
        },
        {
          url: require('@/components/contact/imgs/contact_img4.png'),
          title: "facebook",
          content: ""
        }

      ],
      form: {},
      rulesZh: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        mail: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur'}
        ],
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入内容', trigger: 'blur'},
        ],
        region: [
          {required: true, message: '请选择活动区域', trigger: 'change'}
        ],
        date1: [
          {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        date2: [
          {type: 'date', required: true, message: '请选择时间', trigger: 'change'}
        ],
        type: [
          {type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}
        ],
        resource: [
          {required: true, message: '请选择活动资源', trigger: 'change'}
        ],
        desc: [
          {required: true, message: '请填写活动形式', trigger: 'blur'}
        ]
      },
      rulesEn: {
        name: [
          {required: true, message: 'Please enter your name', trigger: 'blur'},
        ],
        mail: [
          {required: true, message: 'Please enter your E-mail', trigger: 'blur'},
          {type: 'email', message: 'Please enter the correct email format', trigger: 'blur'}
        ],
        title: [
          {required: true, message: 'Please enter your title', trigger: 'blur'},
        ],
        content: [
          {required: true, message: 'Please enter your content', trigger: 'blur'},
        ],
        region: [
          {required: true, message: '请选择活动区域', trigger: 'change'}
        ],
        date1: [
          {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        date2: [
          {type: 'date', required: true, message: '请选择时间', trigger: 'change'}
        ],
        type: [
          {type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}
        ],
        resource: [
          {required: true, message: '请选择活动资源', trigger: 'change'}
        ],
        desc: [
          {required: true, message: '请填写活动形式', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    initMap() {
      // // 创建一个script标签来引入百度地图API
      // const script = document.createElement('script');
      // script.type = 'text/javascript';
      // script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的API密钥&callback=onBMapCallback`;
      // document.body.appendChild(script);
// 创建一个script标签来引入百度地图API
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的API密钥&callback=onBMapCallback`;
      document.body.appendChild(script);
      // 定义回调函数
      window.onBMapCallback = () => {
        const map = new BMap.Map('baiduMap');
        const point = new BMap.Point(102.702187, 24.983998); // 地图中心点坐标
        map.enableScrollWheelZoom(true);
        map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
        const marker = new BMap.Marker(point); // 创建标记点
        map.addOverlay(marker);
        // 可以在这里添加更多地图配置和交互
      };
    },
    shareClick() {
      this.$refs.shareDialog.open('Repost to Facebook', {})
    },
    goBack() {
      this.$router.push({
        path: '/contact',
      })
    },
    /* 提交表单*/
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          addMessageBoard(this.form).then(res => {
            if (res.code === 200) {
              this.dialogVisible = false
              this.$message.success("添加留言板信息成功！")
              this.form = {}
              // this.$parent.getData()
            } else {
              this.$message.error("添加留言板信息失败！")
            }
          })
        } else {
          this.$message("请完整填写信息！")
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;

  }

  .containerbody {
    width: 100%;
    background-color: rgb(249, 249, 249);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;


  }

  .content {
    width: 60%;
    margin: 0 auto;

  }

  .main {
    width: 90%;
    /* height:500px; */
    margin: 20px auto;
    /* // display: flex;
  // align-items: center; */


  }

  .title {
    width: 100%;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
    /* padding:30px auto; */

  }

  .tip {
    width: 100%;
    margin: 30px auto;
    text-align: left;
    font-size: 0.9em;
    line-height: 30px;
    padding-left: 3em;
  }

  .contact_way {
    width: 100%;
    height: 100px;

  }

  .contact_text {
    height: 40px;
    width: 100%;
    margin: 50px 0;
  }

  .contact_text_content {
    width: 100%;
    height: 100%;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    font-weight: normal;
    text-align: justify;
    line-height: 24px;
  }

  .img {

  }

  .img:hover {
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .map {
    //background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/df8337fef9e94889b745f2d8215f468c_mergeImage.png);
    width: 100%;
    height: 60vh;
    margin: 0px 0 28px 0px;
  }

  .card {
    margin-bottom: 12px;

  }
}

@media only screen and (max-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;

  }

  .containerbody {
    width: 100%;
    background-color: rgb(249, 249, 249);
    display: flex;
    flex-direction: column;
    align-items: center;
    //padding: 20px 0;


  }

  .content {
    width: 100%;
    margin: 0 auto;

  }

  .main {
    width: 96%;
    /* height:500px; */
    margin: 20px auto;
    /* // display: flex;
  // align-items: center; */


  }

  .title {
    width: 100%;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
    /* padding:30px auto; */

  }

  .tip {
    width: 100%;
    margin: 30px auto;
    text-align: left;
    font-size: 0.9em;
    line-height: 30px;
    padding-left: 3em;
  }

  .contact_way {
    width: 100%;
    height: 100px;

  }

  .contact_text {
    height: 40px;
    width: 100%;
    margin: 50px 0;
  }

  .contact_text_content {
    width: 100%;
    height: 100%;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    font-weight: normal;
    text-align: justify;
    line-height: 24px;
  }

  .img {

  }

  .img:hover {
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .map {
    //background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/df8337fef9e94889b745f2d8215f468c_mergeImage.png);
    width: 100%;
    height: 60vh;
    margin: 0px 0 18px 0px;
  }

  .card {
    margin-bottom: 12px;

  }
}

</style>




// WEBPACK FOOTER //
// src/components/page/messageBoard.vue